// node-modules
import Barba from 'barba.js/dist/barba';
import NProgress from 'nprogress';

// constants
import { SELECTORS } from '@/scripts/constants';

// others
import { initPlugins } from '@/scripts/plugins';
import { isLoggedAdmin, isEditMode } from '@/scripts/utils';
import transition from './transition';

// assets
import './PageNavigation.scss';

const defaults = {
  usePJAX: false,
};

export default class PageNavigation {
  constructor(props) {
    const options = Object.assign({}, defaults, props);

    this.usePJAX = options.usePJAX;

    PageNavigation.setup();
  }

  static setup() {
    Barba.Pjax.getTransition = () => transition;

    Barba.Utils.xhrTimeout = 20000;

    Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;

    Barba.Pjax.preventCheck = (evt, element) => Barba.Pjax.originalPreventCheck(evt, element) && element.closest(SELECTORS.main_wrapper);

    Barba.Dispatcher.on('linkClicked', () => NProgress.start());

    Barba.Dispatcher.on('transitionCompleted', () => NProgress.done());
  }

  init() {
    return new Promise(async (resolve) => {
      if (this.usePJAX && !isEditMode() && !isLoggedAdmin()) {
        const plugins = await initPlugins(document, this.usePJAX);
        if (plugins) {
          Barba.Prefetch.init();
          Barba.Pjax.start();
          resolve(plugins);
          console.log('BarbaJS enabled. Enjoy!'); // eslint-disable-line no-console
        }
      } else {
        console.log('BarbaJS disabled.'); // eslint-disable-line no-console
        resolve(initPlugins(document));
      }
    });
  }
}

// $('.nav_side-bar li').addClass('active1');
// $('.nav_side-bar li').children('a').each(function(){
//   if($('.nav_side-bar li a').attr('href') === 'articles') {
//     $('.nav_side-bar li').addClass('active1');
//   }
// });

// const lis = document.querySelectorAll('.nav_item');
// console.log(lis);
// lis.addEventListener('click', e => {
//   console.log(e.target);
//   e.target.classList.add('active1');
// });
// let listItems = document.querySelectorAll('.nav_item');
// let listItemsContent = [].slice.call(listItems);
//
// listItemsContent.forEach((el) => {
//   el.addEventListener('click', (e) => {
//     console.log(this);
//     e.target.classList.add('active1');
//   });
// });
// $('.nav_side-bar li').on('click', () => {
//   console.log('test');
//   if($('li'))
//   $('.nav_side-bar li').addClass('active1');
//   //$(this).closest('li').removeClass('active1');
// });
//
// //console.log('test');
// navigation



// WEBPACK FOOTER //
// ./components/PageNavigation/PageNavigation.js